import {useMatch, useNavigate} from "@tanstack/react-location";
import {Box, Heading, useColorMode, Table, Tag, Tbody, Tr, Td} from "@chakra-ui/react";
import humanizeString from "string-humanize";
import {getInvoiceStatusColorScheme} from "./utils/getInvoiceStatusColorScheme";

const InvoiceCard = (props) => {
  const {data = {}} = props;
  const {amount_paid: amountPaid, amount_due: amountDue, currency_code: currencyCode, id, status} = data;
  const {colorMode} = useColorMode();
  const navigate = useNavigate();

  const {
    params: {subscriptionId},
  } = useMatch();

  const colorScheme = getInvoiceStatusColorScheme(status);
  const readableStatus = humanizeString(status);

  return (
    <Box
      borderRadius="3px"
      borderWidth="1px"
      borderColor={colorMode === "light" ? "gray.300" : "gray.600"}
      boxShadow={"0px 3px 6px #00000029"}
      padding="20px"
      overflowX={"auto"}
      onClick={() => navigate({to: `/app/subscriptions/${subscriptionId}/invoices/${id}`})}
    >
      <Table>
        <Tbody>
          <Tr>
            <Td>
              <Heading fontSize={"20px"} fontWeight={700}>
                Status
              </Heading>
            </Td>
            <Td>
              <Tag colorScheme={colorScheme}>{readableStatus}</Tag>
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Heading fontSize={"20px"} fontWeight={700}>
                Amount Paid
              </Heading>
            </Td>
            <Td>{`${amountPaid} ${currencyCode}`}</Td>
          </Tr>
          <Tr>
            <Td>
              <Heading fontSize={"20px"} fontWeight={700}>
                Amount Due
              </Heading>
            </Td>
            <Td>{`${amountDue} ${currencyCode}`}</Td>
          </Tr>
        </Tbody>
      </Table>
    </Box>
  );
};

export default InvoiceCard;
